import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import ModuleProgressStepper from './ModuleProgressStepper';
import currentModuleShape from 'react/signups/card/shapes/CurrentModule';
import userTypeShape from 'react/signups/card/shapes/UserType';
import { getCurrentModuleDisplayName, makeModuleDisplayNameList } from 'react/signups/card/utils';

export default function ModuleProgressList({ cardholderFirstName, currentModule, userType }) {
  const listItems = useMemo(
    () => makeModuleDisplayNameList(cardholderFirstName, userType),
    [cardholderFirstName, userType],
  );

  const currentIndex = useMemo(() => {
    const currentItem = getCurrentModuleDisplayName(currentModule, userType, cardholderFirstName);
    const currentIndex = listItems?.findIndex((val) => val === currentItem);
    return currentIndex;
  }, [cardholderFirstName, currentModule, listItems, userType]);

  return <ModuleProgressStepper activeStep={currentIndex} steps={listItems} />;
}

ModuleProgressList.propTypes = {
  cardholderFirstName: PropTypes.string,
  currentModule: currentModuleShape.isRequired,
  userType: userTypeShape.isRequired,
};

ModuleProgressList.defaultProps = {
  cardholderFirstName: 'Cardholder',
};
